import { render, staticRenderFns } from "./stockin.vue?vue&type=template&id=74f048f9"
import script from "./stockin.vue?vue&type=script&lang=js"
export * from "./stockin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports